// Auto-detect environment and set appropriate URLs
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.includes('192.168');

// Production URLs
const PRODUCTION_BASE_URL = 'https://api.herramientastayrun.com/api/v1/';
const PRODUCTION_API_BASE_URL = 'https://api.herramientastayrun.com/api/v1/';
const PRODUCTION_SERVER_URL = 'https://api.herramientastayrun.com';
const PRODUCTION_FRONTEND_URL = 'https://herramientastayrun.com';

// Local development URLs
const LOCAL_BASE_URL = 'http://localhost:8000/api/v1/';
const LOCAL_API_BASE_URL = 'http://localhost:8000/api/v1/';
const LOCAL_SERVER_URL = 'http://localhost:8000';
const LOCAL_FRONTEND_URL = 'http://localhost:5173';

// Export based on environment
export const BASE_URL = isLocal ? LOCAL_BASE_URL : PRODUCTION_BASE_URL;
export const API_BASE_URL = isLocal ? LOCAL_API_BASE_URL : PRODUCTION_API_BASE_URL;
export const SERVER_URL = isLocal ? LOCAL_SERVER_URL : PRODUCTION_SERVER_URL;
export const FRONTEND_URL = isLocal ? LOCAL_FRONTEND_URL : PRODUCTION_FRONTEND_URL;

// Debug info
console.log(`🌐 Environment: ${isLocal ? 'LOCAL' : 'PRODUCTION'}`);
console.log(`🔗 API Base URL: ${API_BASE_URL}`);

// Working local network URLs for mobile access
// export const BASE_URL = 'http://192.168.3.8:8000/api/v1/';
// export const API_BASE_URL = 'http://192.168.3.8:8000/api/v1/';
// export const SERVER_URL = 'http://192.168.3.8:8000';
// export const FRONTEND_URL = 'http://192.168.3.8:5173';
